import React from "react";
import "./Home.css";
import Product from "./Product";
import { Row, Col, Typography, Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

function Home() {
  return (
    <div className="home">
      {/* ── Hero Banner ── */}
      <div className="home__hero">
        <div className="home__heroContent">
          <Text className="home__heroTagline">New Arrival</Text>
          <Title className="home__heroTitle">The new Aether Pro 15</Title>
          <Text className="home__heroDesc">Experience the next generation of speed and power. Starting at $1099.</Text>
          <Button type="primary" size="large" className="home__heroBtn" icon={<ArrowRightOutlined />}>
            Shop Now
          </Button>
        </div>
      </div>

      <div className="home__container">
        <div className="home__sectionHeader">
          <Title level={3} style={{ margin: 0 }}>Featured Products</Title>
          <Text type="secondary" style={{ cursor: 'pointer', fontWeight: 500 }}>View All {'>'}</Text>
        </div>

        {/* ── Responsive 4-Column Grid ── */}
        <Row gutter={[24, 32]}>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Product
              id="flagship-phone-01"
              title="Aether Pro 15 - Titanium Black, 512GB"
              price={1099.00}
              rating={5}
              image="https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=600&auto=format&fit=crop&q=80"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Product
              id="headphones-anc-02"
              title="Zenith Noise-Cancelling Wireless Headphones"
              price={349.99}
              rating={5}
              image="https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=600&auto=format&fit=crop&q=80"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Product
              id="watch-smart-03"
              title="Chronos Smart Active Watch - Premium Edition"
              price={229.50}
              rating={4}
              image="https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=600&auto=format&fit=crop&q=80"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Product
              id="keyboard-mech-04"
              title="Keyforge Pro Mechanical Keyboard - Quiet Linear Switches"
              price={129.99}
              rating={4}
              image="https://images.unsplash.com/photo-1618384887929-16ec33fab9ef?w=600&auto=format&fit=crop&q=80"
            />
          </Col>
        
          <Col xs={24} sm={12} md={8} lg={6}>
            <Product
              id="insulated-bottle-05"
              title="Veloce Insulated Stainless Steel Bottle (750ml)"
              price={32.00}
              rating={5}
              image="https://images.unsplash.com/photo-1602143407151-7111542de6e8?w=600&auto=format&fit=crop&q=80"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Product
              id="monitor-curved-06"
              title="Spectra 34' Curved QHD Ultrawide Gaming Monitor (165Hz)"
              price={849.99}
              rating={5}
              image="https://images.unsplash.com/photo-1527443224154-c4a3942d3acf?w=800&auto=format&fit=crop&q=80"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Product
              id="camera-mirrorless-07"
              title="Apex R5 Full-Frame Mirrorless Camera (Body Only)"
              price={1899.99}
              rating={5}
              image="https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=600&auto=format&fit=crop&q=80"
            />
          </Col>
          <Col xs={24} sm={12} md={8} lg={6}>
            <Product
              id="laptop-thin-08"
              title="Quantum Book 14' Slim Laptop - M3 Pro Equivalent"
              price={1499.00}
              rating={4}
              image="https://images.unsplash.com/photo-1531297484001-80022131f5a1?w=600&auto=format&fit=crop&q=80"
            />
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Home;
